import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
import { ResponsibilityStatusV1Schema } from "./responsibility-status.js";
export const ActivityTimelineProvenanceSchema = z.enum([
    "audit",
    "approval",
    "patch",
    "report",
    "dk",
    "run",
    "change_request",
]);
export const ActivityTimelineSeveritySchema = z.enum(["INFO", "NOTICE", "WARNING", "CRITICAL"]);
export const ActivityTimelineCategorySchema = z.enum([
    "AUDIT",
    "APPROVAL",
    "CHANGE_REQUEST",
    "PATCH",
    "RUN",
    "REPORT",
    "DEPARTURE_KIT",
    "GOVERNANCE",
]);
export const ActivityTimelineItemV1Schema = z
    .object({
    schemaVersion: z.literal("activity-timeline-item.v1.0"),
    itemId: z.string().min(1),
    occurredAt: z.string().datetime(),
    category: ActivityTimelineCategorySchema,
    headline: z.string().min(1),
    summary: z.string().min(1),
    responsibilityStatus: ResponsibilityStatusV1Schema,
    severity: ActivityTimelineSeveritySchema,
    provenance: ActivityTimelineProvenanceSchema,
    sourceId: z.string().min(1).optional(),
    runId: z.string().min(1).optional(),
})
    .strict();
export const ActivityTimelineViewV1Schema = z
    .object({
    schemaVersion: z.literal("activity-timeline-view.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    generatedAt: z.string().datetime(),
    items: z.array(ActivityTimelineItemV1Schema),
})
    .strict();
//# sourceMappingURL=activity-timeline.js.map